import { render, staticRenderFns } from "./pt.vue?vue&type=template&id=3043aba8&scoped=true&lang=html&"
import script from "./pt.vue?vue&type=script&lang=js&"
export * from "./pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3043aba8",
  null
  
)

export default component.exports